import type { CustomerPopupSubscription } from '@/types/customer/subscriptions'
import { SubscriptionSource } from '@/types'

import Model from './Model'

type FormType = CustomerPopupSubscription
type Type = FormType

export default class PopupSubscriptionModel extends Model {
  static model: FormType = {
    source: SubscriptionSource.Popup,
    email: null,
  }

  static get() {
    return super.get() as FormType
  }

  static prepareWith<T = Type>(model: T) {
    return super.prepareWith(model) as FormType
  }

  static reset<F = Type, S = Type>(formModel: F, snapshot?: S) {
    return super.reset(formModel, snapshot) as F & S
  }

  static mergeTogether<T = Type>(model: T) {
    return super.mergeTogether(model) as Type
  }

  static mergeTogetherAndCutExcess<T = Type>(model: T) {
    return super.mergeTogetherAndCutExcess(model) as FormType
  }

  static onlyModelKeysDiff<T = Type>(snapshot: T, formModel: T) {
    return super.onlyModelKeysDiff(snapshot, formModel) as Partial<FormType>
  }
}
